import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CanMatchFn } from '@angular/router';
import type { Permission } from '../models/permission.model';
import { PermissionService } from '../services/permission.service';

// canMatch (no canActivate) para que Angular pueda evaluar rutas alternativas con el mismo
// path si esta no matchea, en vez de solo bloquear — se usa como
// `canMatch: [permissionGuard('view_orders')]` (ver app.routes.ts en Fase 2).
export const permissionGuard = (permission: Permission): CanMatchFn => {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    if (permissionService.hasPermission(permission)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
};
